import React from 'react'
import styled from 'styled-components'
import { useFocusOnMount } from '../../../hooks/useFocusOnMount'
import { SCREEN_MAX_WIDTH } from '../constants'

type Props = {
  children: React.ReactNode
  maxWidth?: number
}

const Main = styled.main<{ $maxWidth: number }>`
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  margin: 0 auto;
  padding: var(--grid-24) 0;
  box-sizing: border-box;
  outline: none;

  @media (max-width: ${({ $maxWidth }) => $maxWidth}px) {
    padding: var(--grid-24);
  }
`

export const ScreenContainer: React.FC<Props> = ({ children, maxWidth = SCREEN_MAX_WIDTH }) => {
  const mainRef = useFocusOnMount<HTMLElement>()

  return (
    <Main ref={mainRef} tabIndex={-1} $maxWidth={maxWidth}>
      {children}
    </Main>
  )
}
